const initAutocomplete6 = () => {

  const form = document.querySelector('.form-filter');
  const addressInput = document.getElementById('parking_address_3');
  const option = {
    types: ['address'],
    componentRestrictions: {country: 'fr'},
    fields: ['address_components', 'geometry', 'icon', 'name']
  }

  let autocomplete = new google.maps.places.Autocomplete(addressInput, option);

  autocomplete.addListener('place_changed', () => {
    // form.submit();
  })

};

export { initAutocomplete6 };
